import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { Observable, of, from } from 'rxjs';
import { filter, take, switchMap } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { User, roles_roleName as Role } from '../../shared/models/interfaces';

@Injectable({
  providedIn: 'root',
})
export class RolesGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const requiredRoles: Role[] = route.data['roles'];
    return this.authService.getActiveUser().pipe(
      filter((user: User | null) => user !== null),
      take(1),
      switchMap((user: User) => {
        if (this.hasRequiredRoles([user.role], requiredRoles)) {
          return of(true);
        } else {
          this.router.navigate(['/dashboard']);
          return of(false);
        }
      })
    );
  }
  hasRequiredRoles(userRoles: Role[], requiredRoles: Role[]): boolean {
    if (!requiredRoles || requiredRoles.length === 0) {
      return true; // No specific roles required, allow access
    }
    if (!userRoles || userRoles.length === 0) {
      return false; // User has no roles, deny access
    }
    // Check if user has at least one of the required roles
    return userRoles.some((role) => requiredRoles.includes(role));
  }
}
